import { render, staticRenderFns } from "./modalCuadrillas.vue?vue&type=template&id=1c94e825&"
import script from "./modalCuadrillas.vue?vue&type=script&lang=js&"
export * from "./modalCuadrillas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports